const messages: Record<string, string> = {
	'blockedByDevice.description':
		'Se ha detectado que estás usando un navegador de escritorio.\r\nLa plataforma PolicyCheck solo se puede utilizar a través de un dispositivo móvil.\r\nPara continuar, abre el enlace desde un dispositivo móvil.',
	'landing.stepDescription.vehicleImages': 'Toma las fotos de tu vehículo',
	'landing.stepDescription.vehicleInformation': 'Toma las fotos de la documentación',
	'landing.additional-informations-section.title':
		'Antes de iniciar la verificación de tu vehículo, asegúrate que:',
	'landing.additional-informations-section.text':
		'<ul>' +
		"<li class='landing-additional-information-line'>Tienes las llaves y el permiso de circulación en mano.</li>" +
		"<li class='landing-additional-information-line'>Te encuentras en un lugar con buena iluminación y cobertura móvil.</li>" +
		"<li class='landing-additional-information-line'>El vehículo es accesible desde todos los ángulos y todas las ventanas están cerradas.</li>" +
		'</ul>',
	'fourAdditionalPictures.overallDashboard.description':
		'Toma una foto del tablero completo del vehículo.',
	'fourAdditionalPictures.vin.title': 'Número de Bastidor/VIN',
	'fourAdditionalPictures.vin.description':
		'Toma una foto del número de Bastidor/VIN de tu vehículo. Puedes encontrarlo en la pegatina en el cierre de la puerta del conductor o en la esquina inferior izquierda del parabrisas.',
	'dashboardMileage.dashboard.paragraph':
		'Toma una foto del cuentakilómetros del vehículo con el kilometraje totalmente visible. Si tu vehículo tiene pantallas digitales, enciéndelas.',
	'thanks.paragraph.first': 'Gracias por confiar en Mapfre',
	'vehicleImages.description':
		'Toma una foto de la parte delantera, la parte trasera y ambos laterales completos de tu vehículo. La matrícula debe estar visible en las fotos de la parte delantera y trasera.',
	'vehicleImages.details.first': 'Foto de la parte delantera',
	'vehicleImages.details.second': 'Foto del lateral derecho',
	'vehicleImages.details.third': 'Foto de la parte trasera',
	'vehicleImages.details.fourth': 'Foto del lateral izquierdo',
	'completeVehicleImagesModal.hasVehicleImageFront': 'Foto de la parte delantera',
	'completeVehicleImagesModal.hasVehicleImageRear': 'Foto de la parte trasera',
	'completeVehicleImagesModal.hasVehicleImageLeft': 'Foto del lateral izquierdo',
	'completeVehicleImagesModal.hasVehicleImageRight': 'Foto del lateral derecho',
	'fourAdditionalPictures.windshield.description':
		'Toma una foto detallada del parabrisas de tu vehículo.',
	'fourAdditionalPictures.windshield.title': 'Parabrisas',
	'vehicleInformation.headline.first': 'Detalles del vehículo',
	'vehicleInformation.paragraph.first':
		'Toma una foto del anverso del permiso de circulación de tu vehículo',
	'vehicleInformation.paragraph.fourth':
		'Toma una foto del reverso del permiso de circulación de tu vehículo',
	'loader.loading': 'Cargando datos…',
	'loader.error': 'El proceso no pudo ser cargado. Por favor, intenta de nuevo más tarde',
	'connectionError.title': 'Error de conexión',
	'connectionError.description': 'Error de conexión. Intenta cargar la imagen nuevamente',
	'mainError.tryAgain': 'Intenta de nuevo',
	'landing.headline.policyCheck': 'Bienvenido ',
	'landing.paragraph': 'Estás a tan solo tres pasos de terminar el proceso',
	'landing.stepDescription.fourAdditionalPictures': 'Toma las fotos de tu vehículo ',
	'landing.stepDescription.fourDiagonalPerspectives': 'Toma las fotos de la documentación',
	'landing.stepDescription.feedback': 'Danos tu opinión',
	'landing.termsAndConditionsLink':
		'Por favor acepta los términos y condiciones antes de continuar',
	'landing.termsAndConditionsLinkDescription':
		'Tienes las llaves y el permiso de circulación en mano. ',
	'dataPrivacyModal.headline': 'Te encuentras en un lugar con buena iluminación y cobertura móvil.',
	'button.start': 'Comenzar',
	'button.accept': 'Aceptar',
	'button.back': 'Atrás',
	'button.close': 'Cerrar',
	'landing.aboutPolicyCheck': 'Atrás',
	'tutorialModal.headline.first.policyCheck': 'Cerrar',
	'tutorialModal.paragraph.first.policyCheck': '¿Qué está detrás de PolicyCheck?',
	'chooseLang.headline': 'Elige tu idioma preferido',
	'overallDashboardImage.headline': 'Tablero de instrumentos',
	'vinPicture.headline': 'Número de Bastidor/VIN',

	'invalidFile.size.title': 'Tamaño de archivo incorrecto',
	'invalidFile.size.description': 'El tamaño de la imagen es mayor que el máximo requerido.',
	'invalidFile.extension.title': 'Este tipo de archivo no es válido',
	'invalidFile.extension.description':
		'Este tipo de archivo no es válido. Los formatos aceptados en este caso serían: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
